import { render, staticRenderFns } from "./flypay_M5.vue?vue&type=template&id=fd61b9ec&scoped=true&"
import script from "./flypay_M5.vue?vue&type=script&lang=js&"
export * from "./flypay_M5.vue?vue&type=script&lang=js&"
import style0 from "./flypay_M5.vue?vue&type=style&index=0&id=fd61b9ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd61b9ec",
  null
  
)

export default component.exports